export default {
  introduction: 'Welcome to the Living Security Escape Room',
  instructions: 'How the escape room works',
  storyline: 'Story Line: SecureIT!',
  debriefing: 'Some debriefing',
  reset: 'Reset instructions',
};
